import { render, staticRenderFns } from "./gSwiperCommon.vue?vue&type=template&id=a5a1d1fa&"
import script from "./gSwiperCommon.vue?vue&type=script&lang=js&"
export * from "./gSwiperCommon.vue?vue&type=script&lang=js&"
import style0 from "./gSwiperCommon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports